import React from "react";
import http from '../modules/api';

import DatePicker from "react-datepicker";
import { ko } from "date-fns/locale";
import "react-datepicker/dist/react-datepicker.css";

import TextInput from "../modules/common/TextInput";
import SelectBoxV2 from '../modules/common/SelectBoxV2';
import Button from '../modules/common/Button';
import SaveDialogV2 from '../modules/dialogs/SaveDialogV2';
import TitleContentDialogV2 from '../modules/dialogs/TitleContentDialogV2';

import { PreviewRoot } from "./component/PreviewRoot_v2";         
import PreviewTrigger from "./component/PreviewTrigger_v2";
// import { Button } from "react-bootstrap";

/**
 * PostsTableManager (vFinal)
 * - instagram_automation_settings_14.html의 테이블 레이아웃/클래스명 기반
 * - DatePicker로 날짜 범위 필터(한국어)
 * - 검색/상태/유형/기간 필터 + 정렬 + 페이징 + 체크박스 선택/일괄 기능
 * - 외부 전역 JS/jQuery 불필요
 *
 * props:
 *  - posts?: PostRow[]
 *  - pageSizes?: number[]        (기본: [20, 50, 100])
 *  - onClickNewPost?(): void
 *  - onView?(row: PostRow): void
 *  - onEdit?(row: PostRow): void
 *  - onDelete?(row: PostRow): void
 *  - onBulkEdit?(ids: string[]): void
 *  - onBulkDelete?(ids: string[]): void
 *
 * PostRow:
 *  {
 *    id: string;
 *    caption: string;
 *    type: '자동' | '수동';
 *    status: '게시됨' | '예약됨' | '임시저장' | '실패';
 *    publishedDate?: string; // 'YYYY.MM.DD'
 *    publishedTime?: string; // 'HH:mm'
 *    reach?: number | null;
 *    reachDeltaPct?: number | null;
 *    likes?: number | null;
 *    comments?: number | null;
 *    saves?: number | null;
 *    thumbnail?: string;     // 이미지 URL
 *    carouselCount?: number; // 캐러셀의 추가 페이지 수 (ex: +3)
 *  }
 */

// 컴포넌트 바깥 또는 클래스 상단에 상수로
const STATUS_OPTIONS = [
  { text: "게시됨",   value: "PUBLISHED" },
  { text: "예약됨",   value: "SCHEDULED" },
  { text: "임시저장", value: "DRAFT" },
  { text: "실패",     value: "FAILED" },
];

const TYPE_OPTIONS = [
  { text: "자동",     value: "Y" },
  { text: "수동",     value: "N" },
];

// 수동 콘텐츠 편집기 릴스 전용 슬롯. 기존 릴스(item_index=0)는 media_type_cd=R로 하위 호환한다.
const REELS_ITEM_INDEX = 100;

// 콘텐츠 목록 캡션 최대 표시 글자 수 (초과 시 ... 처리)
const CAPTION_PREVIEW_MAX_LENGTH = 40;

const clampInstagramAudioVolume = (value, fallback = 100) => {
  const n = Number(value);
  if (!Number.isFinite(n)) return fallback;
  return Math.max(0, Math.min(100, Math.round(n)));
};

const parseAudioMetaSnapshot = (value) => {
  if (!value) return null;
  if (typeof value === "object") return value;

  try {
    const parsed = JSON.parse(String(value));
    return parsed && typeof parsed === "object" ? parsed : null;
  } catch (e) {
    return null;
  }
};

const firstAudioText = (...values) => {
  for (const value of values) {
    if (value === null || value === undefined) continue;
    const text = String(value).trim();
    if (text) return text;
  }
  return "";
};

const getAudioPreviewUrlFromMeta = (meta) => {
  const source = meta && typeof meta === "object" ? meta : {};
  return firstAudioText(
    source.download_url,
    source.downloadUrl,
    source.progressive_download_url,
    source.preview_url,
    source.previewUrl,
    source.audio_url,
    source.audioUrl,
    source.url
  );
};

export default class InstagramPostList_v4 extends React.Component {
  static defaultProps = { pageSizes: [{value: 20, text: "20개"}, {value: 50, text: "50개"}, {value: 100, text: "100개"}] };

  constructor(props) {
    super(props);
    // const sample = this.samplePosts();
    this.state = {
      // 데이터
      posts: Array.isArray(props.posts) && props.posts.length ? props.posts : [],
      // posts: sample,

      // 필터/검색
      q: "",
      status: "",
      // type: "",
      is_auto: "",
      startDate: null, // DatePicker는 Date 객체
      endDate: null,

      // 페이징/정렬/선택
      page: 1,
      pageSize: 20,
      sortKey: "publishedAt", // 'caption' | 'reach' | 'likes' | 'comments' | 'saves' | 'publishedAt'
      sortDir: "desc",        // 'asc' | 'desc'
      selected: new Set(),
      tutorialListLoaded: false,

      // 삭제 다이얼로그 (v4: Instagram / Threads 실제 게시물 선택 삭제)
      deleteDialogOpen: false,
      deleteTarget: null,
      deleteInstagramPostChecked: false,
      deleteThreadsPostChecked: false,
      deleteProcessing: false,

      // 로딩, 저장 다이얼로그
      save_dialog_show_state: false,
      save_dialog_content: "로딩중 입니다.",
      save_dialog_button_list: [{ title: "확인", type: "1", display_yn:"N" }],
    };
  }

  componentDidMount() {
    console.log("### InstagramPostList_v4 ###")
    this.fetchPostsFromApi();
  }

  /**
   * API 호출: Spring Boot Instagram Media List
   */
  fetchPostsFromApi = async () => {
    const tutorialRequestSeq = (this.tutorialListRequestSeq || 0) + 1;
    this.tutorialListRequestSeq = tutorialRequestSeq;
    this.setState({ tutorialListLoaded: false });

    const { status, is_auto, q, startDate, endDate, page, pageSize, sortKey, sortDir } = this.state;
    const formatDate = (date) => {
      if (!date) return null;
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    };
    try {
      const resp = await http.get("/rest/shop/instagram/media/list", {
        params: {
          status : status === "DRAFT" ? "" : status === "SCHEDULED" ? "READY" : status, // 'DRAFT'는 is_draft로 처리
          is_auto: is_auto,
          post_type : status === "SCHEDULED" ? "SCHEDULED" : "",
          q,
          is_draft: status === "SCHEDULED" ? "N" : status === "DRAFT" ? "Y" : "",    // 필요시 state에서 가져오도록 수정 가능
          startDate: startDate ? formatDate(startDate) : null,
          endDate: endDate ? formatDate(endDate) : null,
          sortKey: sortKey === "publishedAt" ? "reg_date" : sortKey,
          sortDir: sortDir.toUpperCase(), // ASC / DESC
          start: (page - 1) * pageSize,
          rowCnt: pageSize,
        },
      });

      const { total, list } = resp.data;

      // 백엔드 → 프론트 데이터 매핑
      const posts = (list || []).map((m) => {
        const mediaTypeCd = String(m.media_type_cd || "").toUpperCase();

        const audioMeta = parseAudioMetaSnapshot(m.audio_meta_snapshot_json);
        const normalizedAudioType = String(m.instagram_audio_type || "").toUpperCase();
        let audioMode = String(m.audio_mode_cd || "NONE").toUpperCase();
        if (!["MUSIC", "ORIGINAL_SOUND"].includes(audioMode)) {
          audioMode = m.instagram_audio_id && ["MUSIC", "ORIGINAL_SOUND"].includes(normalizedAudioType)
            ? normalizedAudioType
            : "NONE";
        }

        const storedReelsAudio = {
          mode: audioMode,
          audioId: m.instagram_audio_id ? String(m.instagram_audio_id) : "",
          audioType: normalizedAudioType || audioMode,
          title: m.instagram_audio_title || "",
          artist: m.instagram_audio_artist || "",
          durationMs: m.instagram_audio_duration_ms !== null && m.instagram_audio_duration_ms !== undefined
            ? Number(m.instagram_audio_duration_ms)
            : null,
          previewUrl: getAudioPreviewUrlFromMeta(audioMeta),
          audioVolume: clampInstagramAudioVolume(m.audio_volume, 100),
          videoVolume: clampInstagramAudioVolume(m.video_volume, 100),
          audioName: m.audio_name || "",
          mediaAudioType: m.media_audio_type || "",
          meta: audioMeta,
        };

        // 임시저장에는 FEED + REELS 상태가 함께 들어갈 수 있으므로 목록은 현재 media_type_cd에 해당하는
        // 아이템만 노출한다. 신규 릴스는 100번, 기존 릴스는 100번이 없을 때 기존 item을 사용한다.
        const sortedItems = (m.items || [])
          .slice()
          .sort((a,b) => (a.item_index??0) - (b.item_index??0));
        const hasReservedReelsItem = sortedItems.some(
          (it) => Number(it && it.item_index) === REELS_ITEM_INDEX
        );
        const visibleItems = mediaTypeCd === "R"
          ? (hasReservedReelsItem
              ? sortedItems.filter((it) => Number(it && it.item_index) === REELS_ITEM_INDEX)
              : sortedItems)
          : sortedItems.filter((it) => Number(it && it.item_index) !== REELS_ITEM_INDEX);

        // FEED가 현재 선택된 임시저장이라도 DB에는 릴스 음악을 보존하지만, 목록/미리보기에는 숨긴다.
        const reelsAudio = mediaTypeCd === "R"
          ? storedReelsAudio
          : {
              mode: "NONE",
              audioId: "",
              audioType: "",
              title: "",
              artist: "",
              durationMs: null,
              previewUrl: "",
              audioVolume: 100,
              videoVolume: 100,
              audioName: "",
              mediaAudioType: "",
              meta: null,
            };

        const slides = visibleItems
          .map((it) => {
            const sourceUrl = it.source_url || "";
            const rawPreviewUrl =
              it.preview_image_url ||
              it.thumbnail_url ||
              m.thumbnail_url ||
              m.cover_image ||
              "";

            const isVideo =
              mediaTypeCd === "R" ||
              String(it.source_type_cd || "").toUpperCase() === "V" ||
              this.looksLikeVideoUrl(sourceUrl);

            // thumbnail/poster에는 동영상 URL이 들어가면 안 됨.
            // 릴스 썸네일이 아직 없으면 빈 값으로 두고 placeholder + play overlay를 보여준다.
            const safeThumbnail = rawPreviewUrl && !this.looksLikeVideoUrl(rawPreviewUrl)
              ? rawPreviewUrl
              : "";

            return {
              type: isVideo ? "video" : "image",
              url: sourceUrl || safeThumbnail || rawPreviewUrl,
              thumbnail: safeThumbnail,
            };
          })
          .filter((slide) => slide.url || slide.thumbnail);

        const isVideoPost = mediaTypeCd === "R" || slides.some((slide) => slide.type === "video");

        // 목록 썸네일 영역은 <img>로 렌더링되므로 동영상 URL을 커버로 쓰면 깨진다.
        // thumbnail_url / cover_image / slide.thumbnail 중 이미지 URL만 커버로 사용한다.
        const coverCandidates = [
          m.thumbnail_url,
          m.cover_image,
          slides[0]?.thumbnail,
          slides[0]?.url,
        ].filter(Boolean);
        const cover = coverCandidates.find((url) => !this.looksLikeVideoUrl(url)) || "";

        const base = m.published_time || m.scheduled_time;
        const createdBase = m.reg_date;
        const instagramPublishedBase = m.published_time || (m.post_type === "SCHEDULED" ? m.scheduled_time : null);
        const threadsPublishedBase = m.threads_published_at || (m.post_type === "SCHEDULED" ? m.scheduled_time : null);

        const threadsPublishStatusCd = String(
          m.threads_publish_status_cd || m.threads_status || ""
        ).toUpperCase();
        const isPublished =
          String(m.status || "").toUpperCase() === "PUBLISHED" ||
          threadsPublishStatusCd === "PUBLISHED";

        // 임시저장('Y')이면서 예약('SCHEDULED')이 아닌 경우를 체크
        const isDraftNotScheduled = m.is_draft === "Y" && m.post_type !== "SCHEDULED"; 

        return {
          id: String(m.instagram_media_seq),
          caption: m.caption,
          username: m.username || m.ig_username || "",
          threadsUsername: m.threads_username || m.threads_user_id || "",
          facebook_username: m.facebook_username || "",
          status:
            isPublished ? "게시됨" :
            m.status === "FAILED" ? "실패" :
            m.is_draft === "Y" ? "임시저장" :
            m.post_type === "SCHEDULED" ? "예약됨" : m.status,
          createdDate:   createdBase
                          ? new Date(new Date(createdBase).getTime() + 9 * 60 * 60 * 1000)
                              .toISOString()
                              .substring(0, 10)
                              .replace(/-/g, ".")
                          : "",
          createdTime:   createdBase
                          ? new Date(new Date(createdBase).getTime() + 9 * 60 * 60 * 1000)
                              .toISOString()
                              .substring(11, 16)
                          : "",
          publishedDate:  (base && !isDraftNotScheduled)
                          ? new Date(new Date(base).getTime() + 9 * 60 * 60 * 1000)
                              .toISOString()
                              .substring(0, 10)
                              .replace(/-/g, ".")
                          : "",
          publishedTime:  (base && !isDraftNotScheduled)
                          ? new Date(new Date(base).getTime() + 9 * 60 * 60 * 1000)
                              .toISOString()
                              .substring(11, 16)
                          : "",
          instagramPublishedDate: (instagramPublishedBase && !isDraftNotScheduled)
                          ? new Date(new Date(instagramPublishedBase).getTime() + 9 * 60 * 60 * 1000)
                              .toISOString()
                              .substring(0, 10)
                              .replace(/-/g, ".")
                          : "",
          instagramPublishedTime: (instagramPublishedBase && !isDraftNotScheduled)
                          ? new Date(new Date(instagramPublishedBase).getTime() + 9 * 60 * 60 * 1000)
                              .toISOString()
                              .substring(11, 16)
                          : "",
          // Threads 발행일시는 Instagram의 임시저장 여부와 무관하게 표시한다.
          threadsPublishedDate: threadsPublishedBase
                          ? new Date(new Date(threadsPublishedBase).getTime() + 9 * 60 * 60 * 1000)
                              .toISOString()
                              .substring(0, 10)
                              .replace(/-/g, ".")
                          : "",
          threadsPublishedTime: threadsPublishedBase
                          ? new Date(new Date(threadsPublishedBase).getTime() + 9 * 60 * 60 * 1000)
                              .toISOString()
                              .substring(11, 16)
                          : "",
          // 발행 플랫폼 정보
          // - 현재 백엔드가 신규 필드를 내려주면 그대로 사용
          // - 미지원 백엔드에서는 기존 Instagram 목록 동작을 유지하도록 보수적으로 fallback
          instagramPublishYn: String(
            m.instagram_publish_yn ?? "Y"
          ).toUpperCase(),
          threadsPublishYn: String(
            m.threads_publish_yn ?? (m.threads_media_seq || m.threads_media_id ? "Y" : "N")
          ).toUpperCase(),
          instagramMediaId: m.instagram_media_id || null,
          // Facebook / Instagram 직접 로그인 구분 (게시물별 실제 연결 계정 기준)
          instagramAuthProvider: String(m.auth_provider || "").toUpperCase(),
          instagramPermalink: m.permalink || null,
          threadsMediaSeq: m.threads_media_seq ?? null,
          threadsMediaId: m.threads_media_id || null,
          threadsPermalink: m.threads_permalink || null,
          threadsPublishStatusCd: threadsPublishStatusCd || null,

          // Instagram 참여
          view_cnt: m.view_cnt ?? null,
          like_cnt: m.like_cnt ?? null,
          comment_cnt: m.comment_cnt ?? null,
          save_cnt: m.save_cnt ?? null,

          // Threads 참여
          // 백엔드 컬럼명이 확정되기 전까지 흔히 사용하는 alias도 함께 허용한다.
          threads_like_cnt:
            m.threads_like_cnt ?? m.threads_like_count ?? m.threads_likes ?? null,
          threads_reply_cnt:
            m.threads_reply_cnt ?? m.threads_reply_count ?? m.threads_replies ?? m.threads_comment_cnt ?? null,
          threads_view_cnt:
            m.threads_view_cnt ?? m.threads_view_count ?? m.threads_views ?? null,
          thumbnail: cover,              // ← 이미지/동영상 썸네일 커버
          carouselCount: slides.length > 1 ? (slides.length - 1) : null,
          slides,                        // ← 프리뷰용 배열 추가 [{ type, url, thumbnail }]
          isVideoPost,
          hashtags: m.hashtags,          // ← 해시태그 추가
          isAuto: m.is_auto,
          isAutoText: m.is_auto == "Y" ? "자동" : "수동",
          autoSettingType: m.auto_setting_type || "",
          autoSettingName:
            m.auto_setting_name ||
            m.ai_image_auto_setting_name ||
            m.product_auto_setting_name ||
            "",
          instagramAiImageAutoSettingSeq: m.instagram_ai_image_auto_setting_seq || null,
          instagramProductAutoSettingSeq: m.instagram_product_auto_setting_seq || null,
          image_ratio: m.image_ratio || (isVideoPost ? "9/16" : "1/1"),
          reelsAudio,
        };
      });


      this.setState({ posts, total });
    } catch (err) {
      console.error("게시물 목록 조회 실패", err);
    } finally {
      if (this.tutorialListRequestSeq === tutorialRequestSeq) {
        this.setState({ tutorialListLoaded: true });
      }
    }
  };

  // 샘플 데이터 (주입 없을 때)
  samplePosts() {
    return [
      {
        id: "1",
        caption: "겨울 신상품 입고! 🎉",
        type: "자동",
        status: "게시됨",
        publishedDate: "2024.01.15",
        publishedTime: "14:00",
        reach: 1234,
        reachDeltaPct: 15.2,
        likes: 89,
        comments: 12,
        saves: 5,
        thumbnail: "", // 없으면 placeholder
      },
      {
        id: "2",
        caption: "오늘의 데일리룩 추천 👗",
        type: "자동",
        status: "게시됨",
        publishedDate: "2024.01.14",
        publishedTime: "18:30",
        reach: 2456,
        reachDeltaPct: 32.1,
        likes: 156,
        comments: 23,
        saves: 12,
        thumbnail: "",
        carouselCount: 3,
      },
      {
        id: "3",
        caption: "주말 특가! 전 상품 30% 할인 🛍️",
        type: "수동",
        status: "예약됨",
        publishedDate: "2024.01.20",
        publishedTime: "10:00",
        reach: null,
        reachDeltaPct: null,
        likes: null,
        comments: null,
        saves: null,
        thumbnail: "",
      },
      {
        id: "4",
        caption: "권한 문제로 발행 실패",
        type: "자동",
        status: "실패",
        publishedDate: "2024.01.13",
        publishedTime: "12:00",
        reach: null,
        reachDeltaPct: null,
        likes: 0,
        comments: 2,
        saves: 0,
        thumbnail: "",
      },
    ];
  }

  // 유틸
  looksLikeVideoUrl = (url) => {
    const value = String(url || "").split("?")[0].toLowerCase();
    return /\.(mp4|mov|m4v|webm|avi|mpeg|mpg)$/.test(value);
  };

  // 목록에만 축약된 캡션을 표시하고 원본(row.caption)은 그대로 유지한다.
  formatCaptionPreview = (caption) => {
    const text = String(caption ?? "").replace(/\s+/g, " ").trim();
    if (!text) return "-";
    const chars = Array.from(text);
    return chars.length > CAPTION_PREVIEW_MAX_LENGTH
      ? `${chars.slice(0, CAPTION_PREVIEW_MAX_LENGTH).join("")}...`
      : text;
  };

  fmtNumber(n) { return (n === null || n === undefined) ? "-" : n.toLocaleString(); }
  
  // 이벤트
  changeSort = (key) => {
    this.setState((prev) =>
      prev.sortKey === key
        ? { sortDir: prev.sortDir === "asc" ? "desc" : "asc" }
        : { sortKey: key, sortDir: "desc" }
    , this.fetchPostsFromApi);
  };
  handleInput = (e) => {
    const { name, value } = e.target;
    this.setState({ [name]: value, page: 1 });
  };
  setQuickRange = (type) => {
    const today = new Date();
    if (type === "today") {
      this.setState({ startDate: today, endDate: today, page: 1 }, this.fetchPostsFromApi);
    } else if (type === "week") {
      const day = today.getDay();                 // 0=일
      const diff = day === 0 ? 6 : day - 1;       // 월요일 시작
      const monday = new Date(today); monday.setDate(today.getDate() - diff);
      const sunday = new Date(monday); sunday.setDate(monday.getDate() + 6);
      this.setState({ startDate: monday, endDate: sunday, page: 1 }, this.fetchPostsFromApi);
    } else if (type === "month") {
      const first = new Date(today.getFullYear(), today.getMonth(), 1);
      const last = new Date(today.getFullYear(), today.getMonth() + 1, 0);
     this.setState({ startDate: first, endDate: last, page: 1 }, this.fetchPostsFromApi);
    } else {
      // 전체(초기화)
      this.setState({ startDate: null, endDate: null, page: 1 }, this.fetchPostsFromApi);
    }

    this.setState({ dateType: type });
  };

  // 선택/일괄
  toggleSelectAll = (e, rowsOnPage) => {
    const checked = e.target.checked;
    this.setState((prev) => {
      const next = new Set(prev.selected);
      if (checked) rowsOnPage.forEach((r) => next.add(r.id));
      else rowsOnPage.forEach((r) => next.delete(r.id));
      return { selected: next };
    });
  };
  toggleSelectOne = (id) => {
    this.setState((prev) => {
      const next = new Set(prev.selected);
      next.has(id) ? next.delete(id) : next.add(id);
      return { selected: next };
    });
  };

  goPage = (p) => this.setState({ page: p }, this.fetchPostsFromApi);
  changePageSize = (e) => this.setState({ pageSize: Number(e.target.value), page: 1 }, this.fetchPostsFromApi);

  onView = (row) => this.props.onView && this.props.onView(row);
  onEdit = (row) => this.props.onEdit && this.props.onEdit(row);
  isInstagramPublishedRow = (row) => {
    if (!row) return false;
    return row.instagramPublishYn === "Y" && Boolean(row.instagramMediaId);
  };

  // Instagram 직접 로그인은 Meta의 원격 게시물 삭제 기능을 제공하지 않음.
  // Facebook 로그인으로 연결된 게시물의 기존 삭제 권한 검사와 UI는 유지한다.
  isInstagramDirectRow = (row) => Boolean(row && row.instagramAuthProvider === "INSTAGRAM");

  isThreadsPublishedRow = (row) => {
    if (!row) return false;
    const status = String(row.threadsPublishStatusCd || "").toUpperCase();
    return row.threadsPublishYn === "Y"
      && Boolean(row.threadsMediaSeq)
      && (Boolean(row.threadsMediaId) || Boolean(row.threadsPermalink) || status === "PUBLISHED" || status === "SUCCESS");
  };

  openDeleteDialog = (row, e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }

    this.setState({
      deleteDialogOpen: true,
      deleteTarget: row,
      deleteInstagramPostChecked: false,
      deleteThreadsPostChecked: false,
      deleteProcessing: false,
    });
  };

  closeDeleteDialog = () => {
    if (this.state.deleteProcessing) return;

    this.setState({
      deleteDialogOpen: false,
      deleteTarget: null,
      deleteInstagramPostChecked: false,
      deleteThreadsPostChecked: false,
    });
  };

  handleDeleteInstagramCheck = (event) => {
    const target = event && event.target;
    this.setState({ deleteInstagramPostChecked: Boolean(target && target.checked) });
  };

  handleDeleteThreadsCheck = (event) => {
    const target = event && event.target;
    this.setState({ deleteThreadsPostChecked: Boolean(target && target.checked) });
  };

  getDeleteDialogCheckBoxList = () => {
    const row = this.state.deleteTarget;
    if (!row || row.status !== "게시됨") return [];

    const checkBoxList = [];

    if (this.isInstagramPublishedRow(row) && !this.isInstagramDirectRow(row)) {
      checkBoxList.push({
        id: "delete-instagram-remote-checkbox",
        text: "Instagram에 발행된 실제 게시물도 함께 삭제",
        checked: this.state.deleteInstagramPostChecked,
        onChangeCheck: this.handleDeleteInstagramCheck,
        disabled: this.state.deleteProcessing,
      });
    }

    if (this.isThreadsPublishedRow(row)) {
      checkBoxList.push({
        id: "delete-threads-remote-checkbox",
        text: "Threads에 발행된 실제 게시물도 함께 삭제",
        checked: this.state.deleteThreadsPostChecked,
        onChangeCheck: this.handleDeleteThreadsCheck,
        disabled: this.state.deleteProcessing,
      });
    }

    return checkBoxList;
  };

  getDeleteDialogContent = () => {
    const row = this.state.deleteTarget;
    if (!row) return "";

    if (row.status === "게시됨") {
      if (this.isInstagramDirectRow(row) && this.isInstagramPublishedRow(row)) {
        // 직접 로그인 계정은 실제 Instagram 게시물을 삭제하지 않고 로보엠디 목록만 삭제한다.
        // Threads에 함께 발행된 경우 Threads 원격 삭제 선택지는 기존대로 제공한다.
        return this.isThreadsPublishedRow(row)
          ? `로보엠디 콘텐츠 목록에서 삭제합니다.<br/>` +
            `Threads의 실제 게시물도 함께 삭제하려면 아래 항목을 선택해 주세요.<br/><br/>` +
            `<strong>Instagram에 발행된 실제 게시물은 유지됩니다.</strong>`
          : `로보엠디 콘텐츠 목록에서만 삭제합니다.<br/>` +
            `<strong>Instagram에 발행된 실제 게시물은 유지됩니다.</strong>`;
      }
      return (
        `로보엠디 콘텐츠 목록에서 삭제합니다.<br/>` +
        `실제 게시물도 함께 삭제하려면 아래 항목을 선택해 주세요.<br/><br/>` +
        `<strong>선택하지 않은 플랫폼의 실제 게시물은 유지됩니다.</strong>`
      );
    }
    if (row.status === "예약됨") {
      return "예약 콘텐츠를 삭제하면 예정된 시간에 게시되지 않습니다.<br/>삭제한 콘텐츠는 복구할 수 없습니다.";
    }
    if (row.status === "임시저장") {
      return "임시저장 콘텐츠를 목록에서 삭제합니다.<br/>삭제한 콘텐츠는 복구할 수 없습니다.";
    }
    if (row.status === "실패") {
      return "발행에 실패한 콘텐츠를 목록에서 삭제합니다.<br/>삭제한 콘텐츠는 복구할 수 없습니다.";
    }

    return "콘텐츠를 목록에서 삭제합니다.<br/>삭제한 콘텐츠는 복구할 수 없습니다.";
  };

  deletePost = async () => {
    const {
      deleteTarget,
      deleteInstagramPostChecked,
      deleteThreadsPostChecked,
      deleteProcessing,
    } = this.state;

    if (!deleteTarget || deleteProcessing) return;

    // UI 상태가 남아 있어도 Instagram 직접 로그인 게시물에 원격 삭제 API를 호출하지 않는다.
    const deleteInstagramToo = this.isInstagramPublishedRow(deleteTarget)
      && !this.isInstagramDirectRow(deleteTarget)
      && deleteInstagramPostChecked;
    const deleteThreadsToo = this.isThreadsPublishedRow(deleteTarget) && deleteThreadsPostChecked;

    this.setState({
      deleteProcessing: true,
      save_dialog_show_state: true,
      save_dialog_content: "삭제 중 입니다...",
      save_dialog_button_list: [{ title: "확인", type: "1", display_yn:"N" }],
    });

    try {
      // Threads 실제 게시물은 TB_THREADS_MEDIA의 로컬 seq로 삭제한다.
      // 공통 Instagram row를 먼저 삭제하면 이후 흐름 추적이 어려워질 수 있어 Threads를 먼저 처리한다.
      if (deleteThreadsToo) {
        const threadsResponse = await http.delete(`/rest/shop/threds/media/${deleteTarget.threadsMediaSeq}`);
        const threadsData = threadsResponse && threadsResponse.data ? threadsResponse.data : {};
        if (threadsData.status && threadsData.status !== "success") {
          throw new Error(threadsData.message || "Threads 게시물 삭제에 실패했습니다.");
        }
      }

      // Instagram 실제 게시물 삭제를 선택한 경우 기존 삭제 API를 사용한다.
      // 선택하지 않은 경우 공통 목록 데이터만 삭제한다.
      const deleteUrl = deleteInstagramToo
        ? `/rest/shop/instagram/media/${deleteTarget.id}`
        : `/rest/shop/instagram/media/${deleteTarget.id}/db-only`;

      const response = await http.delete(deleteUrl);
      const data = response && response.data ? response.data : {};

      // 실제 Instagram 게시물 삭제 권한이 없으면 계정 관리에서 재연동하도록 이동
      if (deleteInstagramToo && (data.status === "MISSING_PERMISSIONS" || data.error_code === "MISSING_PERMISSIONS")) {
        const requiredPermission =
          data.required_permission ||
          (Array.isArray(data.missing_permissions_en) && data.missing_permissions_en[0]) ||
          "instagram_manage_contents";

        this.setState({
          deleteDialogOpen: false,
          deleteTarget: null,
          deleteInstagramPostChecked: false,
          deleteThreadsPostChecked: false,
          deleteProcessing: false,
          save_dialog_show_state: false,
        }, () => {
          window.location.href = `/shop/instagram/InstagramAccountManager?required_permission=${encodeURIComponent(requiredPermission)}`;
        });
        return;
      }

      if (data.status && data.status !== "success") {
        throw new Error(data.message || "콘텐츠 삭제에 실패했습니다.");
      }

      let successMessage = "목록에서 콘텐츠를 삭제했습니다.";
      if (deleteInstagramToo && deleteThreadsToo) {
        successMessage = "Instagram과 Threads 게시물 및 목록 데이터를 삭제했습니다.";
      } else if (deleteInstagramToo) {
        successMessage = "Instagram 게시물과 목록 데이터를 삭제했습니다.";
      } else if (deleteThreadsToo) {
        successMessage = "Threads 게시물과 목록 데이터를 삭제했습니다.";
      }

      this.setState({
        deleteDialogOpen: false,
        deleteTarget: null,
        deleteInstagramPostChecked: false,
        deleteThreadsPostChecked: false,
        deleteProcessing: false,
        selected: new Set(),
      }, async () => {
        await this.fetchPostsFromApi();
        this.setState({
          save_dialog_show_state: true,
          save_dialog_content: successMessage,
          save_dialog_button_list: [{
            title: "확인",
            type: "1",
            display_yn:"Y",
            event_method: () => this.setState({ save_dialog_show_state: false }),
          }],
        });
      });
    } catch (err) {
      console.error("콘텐츠 삭제 실패", err);
      const message = err?.response?.data?.message || err?.message || "콘텐츠 삭제에 실패했습니다.";
      this.setState({
        deleteProcessing: false,
        save_dialog_show_state: true,
        save_dialog_content: message,
        save_dialog_button_list: [{
          title: "확인",
          type: "1",
          display_yn: "Y",
          event_method: () => this.setState({ save_dialog_show_state: false }),
        }],
      });
    }
  };

  onDelete = (row, e) => this.openDeleteDialog(row, e);
  onBulkEdit = () => this.props.onBulkEdit && this.props.onBulkEdit(Array.from(this.state.selected));
  onBulkDelete = () => this.props.onBulkDelete && this.props.onBulkDelete(Array.from(this.state.selected));

  renderSortHead(label, key, align = "left", width = "auto", extraProps = {}) {
    const { sortKey, sortDir } = this.state;
    const active = sortKey === key;
    const arrow = active ? (sortDir === "asc" ? "▲" : "▼") : "";
    return (
      <th
        {...extraProps}
        onClick={() => this.changeSort(key)}
        style={{ width: width, cursor: "pointer", textAlign: align }}
        title="정렬"
      >
        {label} {arrow}
      </th>
    );
  }

  // 클래스 컴포넌트 내부 메서드(기존 handleInput 사용과 호환)
  handleSelectBox = (name) => (text, value /*, id*/) => {
    // 기존 this.handleInput(e) 로직과 맞추기 위해 synthetic event 형태로 호출
    this.handleInput({ target: { name, value } });
  };

  renderListPageStyles() {
    return (
      <style>{`
        .instagram-post-page {
          --primary-mint: #00e2e6;
          --primary-dark: #00bfc2;
          --navy-dark: #0A1A2F;
          --bg-body: #f4f7f9;
          --bg-canvas: #ffffff;
          --text-primary: #111827;
          --text-secondary: #4b5563;
          --text-muted: #9ca3af;
          --border-color: #e5e7eb;
          --border-light: #f3f4f6;
          background-color: var(--bg-body);
          color: var(--text-primary);
          display: flex;
          min-height: 100vh;
          overflow-x: hidden;
          width: 100%;
          letter-spacing: 0;
          padding-top: 72px !important;
          max-width: 100% !important;
          min-width: 100% !important;
        }

        .instagram-post-page * {
          box-sizing: border-box;
          font-family: 'Noto Sans KR', sans-serif;
          letter-spacing: 0;
        }

        .instagram-post-page f-s-12 {
          font-size: 12px;
        }
       
        .instagram-post-page f-s-13 {
          font-size: 13px;
        }

        .instagram-post-page f-w-900 {
          font-weight: 900;
        }

        .instagram-post-page button,
        .instagram-post-page input {
          font-family: inherit;
        }

        .instagram-post-page .btn {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
          border: none;
          border-radius: 8px;
          font-size: 15px;
          font-weight: 700;
          cursor: pointer;
          transition: all 0.2s ease;
          // padding: 14px 28px;
          padding: 0px 0px !important;
        }
        .instagram-post-page .btn_mint {
          background: var(--primary-mint);
          color: var(--navy-dark);
          box-shadow: 0 4px 16px rgba(0, 226, 230, 0.35);
        }
        .instagram-post-page .btn_mint:hover {
            background: var(--primary-dark)!important;
            transform: translateY(-2px)!important;
            box-shadow: 0 6px 20px rgba(0, 226, 230, 0.45)!important;
        }

        .instagram-post-page .main-content {
          display: flex;
          flex: 1;
          flex-direction: column;
          min-width: 0;
          width: 100%;
        }

        .instagram-post-page .content-inner {
          display: flex;
          flex: 1;
          flex-direction: column;
          gap: 32px;
          margin: 0 auto;
          max-width: 1600px;
          padding: 32px 40px;
          width: 100%;
          min-height: calc(100vh - 72px);
        }

        .instagram-post-page .center-hero {
          align-items: center;
          display: flex;
          flex-direction: column;
          gap: 12px;
          margin-bottom: 8px;
          text-align: center;
        }

        .instagram-post-page .center-hero h2 {
          color: var(--navy-dark);
          font-size: 22px;
          font-weight: 800;
          margin: 0;
        }

        .instagram-post-page .center-hero p {
          color: var(--text-secondary);
          font-size: 14px;
          line-height: 1.5;
          margin: 0 0 12px;
          max-width: 800px;
          word-break: keep-all;
        }

        .instagram-post-page .hero-action {
          align-items: center;
          display: inline-flex;
          gap: 8px;
        }

        .instagram-post-page .list-section-wrapper {
          background: var(--bg-canvas);
          border: 1px solid var(--border-color);
          border-radius: 12px;
          box-shadow: 0 2px 8px rgba(10, 26, 47, 0.02);
          overflow: hidden;
        }

        .instagram-post-page .filter-header {
          border-bottom: 1px solid var(--border-color);
          display: flex;
          flex-direction: column;
          gap: 16px;
          padding: 20px;
        }

        .instagram-post-page .filter-controls-row {
          align-items: center;
          display: flex;
          flex-wrap: wrap;
          gap: 12px;
        }

        .instagram-post-page .search-box-unified {
          align-items: center;
          background: var(--bg-canvas);
          border: 1px solid var(--border-color);
          border-radius: 6px;
          display: flex;
          flex: 2;
          min-width: 250px;
          padding: 0 14px;
          transition: border-color 0.2s;
        }

        .instagram-post-page .search-box-unified:focus-within {
          border-color: var(--primary-mint);
        }

        .instagram-post-page .fa {
          font-family: FontAwesome !important;
          font-style: normal;
          font-weight: normal;
        }

        .instagram-post-page .search-icon {
          color: var(--text-muted);
          font-size: 14px;
          flex-shrink: 0;
        }
        
        .instagram-post-page #search_q {
          border: none;
        }
        
        .instagram-post-page .select_area {
          border-color: var(--border-color) !important;
          border-radius: 6px !important;
        }

        .instagram-post-page .react-datepicker-wrapper {
          margin-bottom: 0 !important;
        }

        .instagram-post-page .filter-select-wrap {
          flex: 1;
          min-width: 130px;
        }

        .instagram-post-page .date-range-group {
          align-items: center;
          display: flex;
          flex: 1.5;
          gap: 8px;
          min-width: 290px;
        }

        .instagram-post-page .date-input {
          border: 1px solid var(--border-color);
          border-radius: 6px;
          cursor: pointer;
          font-size: 13px;
          outline: none;
          padding: 10px 14px;
          text-align: center;
          width: 100%;
        }

        .instagram-post-page .date-picker-wrapper {
          flex: 1;
        }

        .instagram-post-page .btn-apply {
          background: #64748b;
          border: none;
          border-radius: 6px;
          color: #fff;
          cursor: pointer;
          font-size: 13px;
          font-weight: 600;
          padding: 10px 24px;
          transition: all 0.2s;
          white-space: nowrap;
        }

        .instagram-post-page .btn-apply:hover {
          background: var(--navy-dark);
        }

        .instagram-post-page .filter-chips-row {
          align-items: center;
          display: flex;
          flex-wrap: wrap;
          gap: 12px;
          justify-content: space-between;
        }

        .instagram-post-page .chip-group {
          display: flex;
          flex-wrap: wrap;
          gap: 6px;
        }

        .instagram-post-page .chip-btn {
          background: var(--bg-canvas);
          border: 1px solid var(--border-color);
          border-radius: 20px;
          color: var(--text-secondary);
          cursor: pointer;
          font-size: 12px;
          font-weight: 600;
          padding: 6px 14px;
          transition: all 0.2s;
          white-space: nowrap;
        }

        .instagram-post-page .chip-btn:hover:not(.active) {
          background: var(--border-light);
        }

        .instagram-post-page .chip-btn.active {
          background: #e2e8f0;
          border-color: #cbd5e1;
          color: #1e293b;
          font-weight: 700;
        }

        .instagram-post-page .total-count {
          color: var(--text-secondary);
          font-size: 13px;
          white-space: nowrap;
        }

        .instagram-post-page .total-count span {
          color: var(--navy-dark);
          font-weight: 700;
        }

        .instagram-post-page .table-responsive {
          overflow-x: auto;
          width: 100%;
        }

        .instagram-post-page .robo-table {
          border-collapse: collapse;
          min-width: 1520px;
          text-align: center;
          width: 100%;
        }

        .instagram-post-page .robo-table th {
          background: #f8fafc;
          border-bottom: 1px solid var(--border-color);
          color: var(--navy-dark);
          font-size: 13px;
          font-weight: 700;
          padding: 16px 12px;
          white-space: nowrap;
        }

        .instagram-post-page .robo-table td {
          border-bottom: 1px solid var(--border-light);
          color: var(--text-secondary);
          font-size: 13px;
          padding: 16px 12px;
          vertical-align: middle;
        }

        .instagram-post-page .robo-table tr:hover {
          background: #f8fafc;
        }

        .instagram-post-page .robo-table .text-left {
          text-align: left;
        }

        .instagram-post-page .cell-account {
          color: var(--text-primary);
          line-height: 1.4;
          word-break: keep-all;
        }

        .instagram-post-page .cell-account span {
          color: var(--text-muted);
          display: block;
          font-size: 12px;
          margin-top: 2px;
        }

        .instagram-post-page .cell-link {
          color: var(--primary-dark);
          display: inline-block;
          font-weight: 600;
          line-height: 1.4;
          max-width: 190px;
          overflow: hidden;
          text-decoration: none;
          text-overflow: ellipsis;
          white-space: nowrap;
          word-break: keep-all;
        }

        .instagram-post-page .robo-table td a.cell-link {
          color: var(--primary-dark) !important;
          cursor: pointer;
          text-decoration: none !important;
          transition: color 0.15s ease;
        }

        .instagram-post-page .robo-table td a.cell-link:hover,
        .instagram-post-page .robo-table td a.cell-link:focus-visible {
          text-decoration: underline !important;
        }

        .instagram-post-page .list-no {
          color: var(--text-secondary);
          font-weight: 600;
        }

        .instagram-post-page .thumb-img,
        .instagram-post-page .thumb-media {
          border: 1px solid var(--border-color);
          border-radius: 8px;
          box-shadow: 0 2px 4px rgba(0,0,0,0.05);
          height: 64px;
          width: 64px;
        }

        .instagram-post-page .thumb-img {
          display: block;
          object-fit: cover;
        }

        .instagram-post-page .thumb-media {
          background: #111827;
          overflow: hidden;
          position: relative;
        }

        .instagram-post-page .thumb-media img {
          display: block;
          height: 100%;
          object-fit: cover;
          width: 100%;
        }

        .instagram-post-page .thumb-media.thumb-placeholder {
          background: linear-gradient(135deg, #667eea, #764ba2);
          display: flex;
          justify-content: center;
          align-items: center;
          color: white;
        }

        .instagram-post-page .thumb-video-dim {
          position: absolute;
          inset: 0;
          background: rgba(0,0,0,0.18);
          pointer-events: none;
        }

        .instagram-post-page .thumb-play-icon {
          position: absolute;
          top: 50%;
          left: 50%;
          width: 28px;
          height: 28px;
          transform: translate(-50%, -50%);
          border-radius: 50%;
          background: rgba(255,255,255,0.92);
          display: flex;
          align-items: center;
          justify-content: center;
          pointer-events: none;
          box-shadow: 0 3px 8px rgba(0,0,0,0.25);
        }

        .instagram-post-page .thumb-play-icon span {
          margin-left: 2px;
          width: 0;
          height: 0;
          border-top: 7px solid transparent;
          border-bottom: 7px solid transparent;
          border-left: 10px solid #111827;
        }

        .instagram-post-page .thumb-count-badge {
          position: absolute;
          right: 5px;
          top: 5px;
          padding: 2px 6px;
          border-radius: 999px;
          background: rgba(17, 24, 39, 0.78);
          color: #fff;
          font-size: 10px;
          font-weight: 700;
          line-height: 1.2;
        }

        .instagram-post-page .caption-text {
          color: var(--text-primary);
          font-size: 14px;
          font-weight: 500;
          line-height: 1.5;
          word-break: break-all;
        }

        .instagram-post-page .caption-preview {
          display: block;
          max-width: 100%;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .instagram-post-page .badge {
          align-items: center;
          border-radius: 20px;
          display: inline-flex;
          font-size: 12px;
          font-weight: 700;
          gap: 4px;
          justify-content: center;
          padding: 5px 12px;
          white-space: nowrap;
        }

        .instagram-post-page .badge-mint {
          background: rgba(0, 226, 230, 0.15);
          color: #008f91;
        }

        .instagram-post-page .badge-gray {
          background: #f1f5f9;
          color: #475569;
        }

        .instagram-post-page .badge-blue {
          background: #e0f2fe;
          color: #0369a1;
        }

        .instagram-post-page .badge-red {
          background: #fee2e2;
          color: #b91c1c;
        }

        .instagram-post-page .badge-yellow {
          background: #fef3c7;
          color: #92400e;
        }

        .instagram-post-page .cell-date {
          color: var(--text-primary);
          font-weight: 500;
          line-height: 1.4;
        }

        .instagram-post-page .cell-date span {
          color: var(--text-muted);
          display: block;
          font-size: 12px;
          font-weight: 400;
          margin-top: 2px;
        }

        .instagram-post-page .platform-date-list {
          display: flex;
          flex-direction: column;
          gap: 7px;
          min-width: 150px;
        }

        .instagram-post-page .platform-date-row {
          align-items: flex-start;
          display: flex;
          gap: 7px;
          justify-content: flex-start;
        }

        .instagram-post-page .platform-date-value {
          color: var(--text-primary);
          font-size: 11px;
          line-height: 1.35;
          text-align: center;
          white-space: nowrap;
        }

        .instagram-post-page .platform-date-value span {
          color: var(--text-muted);
          display: block;
          font-size: 10px;
          margin-top: 1px;
        }

        .instagram-post-page .platform-engagement-list {
          display: flex;
          flex-direction: column;
          gap: 7px;
          min-width: 210px;
        }

        .instagram-post-page .platform-engagement-row {
          align-items: center;
          display: flex;
          gap: 8px;
          justify-content: flex-start;
          min-height: 24px;
        }

        .instagram-post-page .platform-engagement-label {
          background: #f8fafc;
          border: 1px solid var(--border-color);
          border-radius: 999px;
          color: var(--text-secondary);
          flex: 0 0 72px;
          font-size: 10px !important;
          font-weight: 500 !important;
          line-height: 20px;
          padding: 0 7px;
          text-align: center;
          white-space: nowrap;
        }

        .instagram-post-page .platform-engagement-label.instagram {
          color: #7c3aed;
        }

        .instagram-post-page .platform-engagement-label.threads {
          color: #111827;
        }

        .instagram-post-page .engagement-box {
          align-items: center;
          color: var(--text-secondary);
          display: flex;
          font-size: 12px;
          gap: 10px;
          justify-content: flex-start;
          min-width: 0;
        }

        .instagram-post-page .engagement-box.active {
          color: var(--text-primary);
          font-weight: 700;
        }

        .instagram-post-page .engagement-item {
          align-items: center;
          display: flex;
          gap: 4px;
          white-space: nowrap;
        }

        .instagram-post-page .engagement-heart {
          color: #ef4444;
        }

        .instagram-post-page .engagement-comment,
        .instagram-post-page .engagement-view {
          color: #64748b;
        }

        .instagram-post-page .engagement-empty {
          color: var(--text-muted);
          font-size: 12px;
          text-align: center;
        }

        .instagram-post-page .pagination-container {
          align-items: center;
          display: flex;
          flex-wrap: wrap;
          gap: 16px;
          justify-content: space-between;
          padding: 16px 20px;
        }

        .instagram-post-page .page-numbers {
          display: flex;
          gap: 4px;
          margin: 0 auto;
        }

        .instagram-post-page .page-numbers button {
          align-items: center;
          background: var(--bg-canvas);
          border: 1px solid var(--border-color);
          border-radius: 4px;
          color: var(--text-secondary);
          cursor: pointer;
          display: inline-flex;
          font-size: 13px;
          font-weight: 500;
          height: 32px;
          justify-content: center;
          transition: all 0.2s;
          width: 32px;
        }

        .instagram-post-page .page-numbers button:hover:not(:disabled) {
          background: var(--border-light);
        }

        .instagram-post-page .page-numbers button.active {
          background: #e2e8f0;
          border-color: #cbd5e1;
          color: #1e293b;
          font-weight: 700;
        }

        .instagram-post-page .page-numbers button:disabled {
          cursor: not-allowed;
          opacity: 0.45;
        }

        .instagram-post-page .page-size-selector {
          align-items: center;
          color: var(--text-secondary);
          display: flex;
          font-size: 13px;
          gap: 8px;
        }

        .instagram-post-page .empty-row {
          color: var(--text-muted);
          padding: 40px;
          text-align: center;
        }

        .instagram-post-page .post-action-wrap {
          align-items: center;
          display: flex;
          justify-content: center;
          min-width: 76px;
          white-space: nowrap;
        }

        .instagram-post-page .post-delete-btn {
          align-items: center;
          background: #fff;
          border: 1px solid #333;
          border-radius: 6px;
          color: #333;
          cursor: pointer;
          display: inline-flex;
          font-size: 12px;
          font-weight: 700;
          gap: 5px;
          justify-content: center;
          min-width: 70px;
          padding: 7px 10px;
          transition: all 0.2s ease;
          white-space: nowrap;
          word-break: keep-all;
        }

        .instagram-post-page .post-delete-btn:hover {
          border-color: var(--primary-mint) !important;
          background: #f0fdfe !important;
        }

        .instagram-post-page .platform-account-list {
          display: flex;
          flex-direction: column;
          gap: 7px;
          min-width: 160px;
        }

        .instagram-post-page .platform-account-row {
          display: flex;
          align-items: center;
          gap: 8px;
        }

        .instagram-post-page .platform-account-label {
          background: #f8fafc;
          border: 1px solid var(--border-color);
          border-radius: 999px;
          flex: 0 0 72px;
          font-size: 10px;
          font-weight: 500;
          line-height: 20px;
          padding: 0 7px;
          text-align: center;
          white-space: nowrap;
        }

        .instagram-post-page .platform-account-label.instagram {
          color: #7c3aed;
        }

        .instagram-post-page .platform-account-label.threads {
          color: #111827;
        }

        .instagram-post-page .platform-account-name {
          color: var(--text-primary);
          font-size: 12px;
          white-space: nowrap;
        }

        @media screen and (max-width: 1024px) {
          .instagram-post-page .content-inner {
            gap: 24px;
            padding: 24px 16px;
          }
        }

        @media screen and (max-width: 800px) {
          .instagram-post-page .center-hero {
            gap: 14px;
            margin-bottom: 8px;
          }

          .instagram-post-page .center-hero h2 {
            font-size: 22px;
          }

          .instagram-post-page .center-hero p {
            font-size: 13px;
            margin: 0;
            padding: 0 16px;
            word-break: keep-all;
          }

          .instagram-post-page .filter-controls-row {
            align-items: stretch;
            flex-direction: column;
          }

          .instagram-post-page .search-box-unified,
          .instagram-post-page .filter-select-wrap {
            width: 100%;
          }

          .instagram-post-page .date-range-group {
            justify-content: space-between;
            min-width: 0;
            width: 100%;
          }

          .instagram-post-page .date-input {
            width: 100%;
          }

          .instagram-post-page .btn-apply {
            width: 100%;
          }

          .instagram-post-page .filter-chips-row {
            align-items: center;
            flex-direction: row;
            flex-wrap: nowrap;
            gap: 8px;
            justify-content: space-between;
          }

          .instagram-post-page .chip-group {
            flex-wrap: nowrap;
            overflow-x: auto;
            scrollbar-width: none;
          }

          .instagram-post-page .chip-group::-webkit-scrollbar {
            display: none;
          }

          .instagram-post-page .total-count {
            flex-shrink: 0;
            margin-left: auto;
          }

          .instagram-post-page .table-responsive {
            overflow-x: visible;
          }

          .instagram-post-page .robo-table,
          .instagram-post-page .robo-table tbody {
            display: block;
            min-width: 100%;
            width: 100%;
          }

          .instagram-post-page .robo-table thead {
            display: none;
          }

          .instagram-post-page .robo-table tr {
            align-items: center;
            background: var(--bg-canvas);
            border: 1px solid var(--border-color);
            border-radius: 12px;
            box-shadow: 0 2px 8px rgba(10, 26, 47, 0.03);
            display: grid;
            gap: 12px;
            grid-template-areas:
              "no status"
              "thumb caption"
              "account account"
              "type created"
              "setting setting"
              "published published"
              "engagement engagement"
              "action action";
            grid-template-columns: 70px 1fr;
            margin-bottom: 16px;
            padding: 16px;
          }

          .instagram-post-page .robo-table tr:hover {
            background: var(--bg-canvas);
          }

          .instagram-post-page .robo-table td {
            border: none;
            display: flex;
            padding: 0;
            text-align: left;
            width: 100%;
          }

          .instagram-post-page .robo-table td:nth-child(1) {
            color: var(--text-muted);
            font-size: 12px;
            font-weight: 700;
            grid-area: no;
          }

          .instagram-post-page .robo-table td:nth-child(1)::before {
            content: "No. ";
            margin-right: 4px;
          }

          .instagram-post-page .robo-table td:nth-child(2) {
            align-self: start;
            grid-area: thumb;
          }

          .instagram-post-page .thumb-img,
          .instagram-post-page .thumb-media {
            height: 70px;
            width: 70px;
          }

          .instagram-post-page .robo-table td:nth-child(3) {
            align-self: start;
            border-bottom: 1px solid var(--border-light);
            grid-area: caption;
            padding-bottom: 8px;
          }

          .instagram-post-page .robo-table td:nth-child(4) {
            align-items: center;
            border-bottom: 1px solid var(--border-light);
            grid-area: account;
            justify-content: space-between;
            padding-bottom: 8px;
          }

          .instagram-post-page .robo-table td:nth-child(4)::before {
            color: var(--text-muted);
            content: "계정";
            flex-shrink: 0;
            font-size: 12px;
            font-weight: 700;
            margin-right: 12px;
          }

          .instagram-post-page .robo-table td:nth-child(4).cell-account {
            text-align: right;
          }

          .instagram-post-page .robo-table td:nth-child(5) {
            align-items: center;
            grid-area: type;
          }

          .instagram-post-page .robo-table td:nth-child(6) {
            align-items: center;
            border-top: 1px dashed var(--border-light);
            display: flex;
            grid-area: setting;
            justify-content: space-between;
            padding-top: 12px;
          }

          .instagram-post-page .robo-table td:nth-child(6)::before {
            color: var(--text-muted);
            content: "자동화 설정";
            flex-shrink: 0;
            font-size: 12px;
            font-weight: 700;
            margin-right: 12px;
          }

          .instagram-post-page .robo-table td:nth-child(6) .cell-link {
            max-width: calc(100% - 100px);
            text-align: right;
          }

          .instagram-post-page .robo-table td:nth-child(7) {
            display: flex;
            grid-area: status;
            justify-content: flex-end;
          }

          .instagram-post-page .robo-table td:nth-child(8) {
            display: flex;
            grid-area: created;
            justify-content: flex-end;
            white-space: nowrap;
          }

          .instagram-post-page .robo-table td:nth-child(9) {
            display: flex;
            grid-area: published;
            justify-content: flex-end;
            white-space: nowrap;
          }

          .instagram-post-page .cell-date br {
            display: none;
          }

          .instagram-post-page .cell-date span {
            display: inline-block;
            margin-left: 4px;
            margin-top: 0;
          }

          .instagram-post-page .robo-table td:nth-child(10) {
            border-top: 1px dashed var(--border-light);
            display: flex;
            grid-area: engagement;
            justify-content: flex-end;
            margin-top: 4px;
            padding-top: 12px;
          }

          .instagram-post-page .robo-table td:nth-child(11) {
            display: flex;
            grid-area: action;
            justify-content: flex-end;
          }

          .instagram-post-page .post-delete-btn {
            width: 100%;
          }

          .instagram-post-page .platform-engagement-list {
            margin-left: auto;
            min-width: 0;
            width: 100%;
          }

          .instagram-post-page .platform-engagement-row {
            justify-content: flex-end;
          }

          .instagram-post-page .engagement-box {
            justify-content: flex-end;
          }

          .instagram-post-page .pagination-container {
            // flex-direction: column;
            gap: 16px;
            justify-content: center;
            padding: 16px 0;
          }

          .instagram-post-page .page-numbers {
            margin: 0;
          }

          .mobile-display-none {
            display: none;
          }

          // .instagram-post-page .page-size-selector {
          //   display: none;
          // }
        }
      `}</style>
    );
  }


  render() {
    const { pageSizes } = this.props;
    const { q, startDate, endDate, page, pageSize, dateType } = this.state;
    const rows = this.state.posts;                  // 서버가 준 현재 페이지
    const total = this.state.total ?? rows.length;  // 서버 total 사용
    const totalPages = Math.max(1, Math.ceil(total / pageSize));

    return (
      <PreviewRoot>
        <div
          id="page-wrapper"
          className="instagram-post-page"
          data-instagram-tutorial-ready={this.state.tutorialListLoaded ? "true" : "false"}
        >
          {this.renderListPageStyles()}

          <main className="main-content">
            <div className="content-inner">
              <section className="center-hero">
                <h2>콘텐츠 목록</h2>
                <p>Instagram과 Threads에 생성 및 예약된 콘텐츠의 발행 상태와 고객 참여 통계를 한눈에 확인하고 관리하세요.</p>
                <div className="hero-action">
                  <Button
                    type={"btn btn_mint"}
                    width={"190px"}
                    height={"48px"}
                    // fontSize={"0.95rem"}
                    onClick={() => { window.location.href = "/shop/instagram/InstagramCreatePost"; }}
                  >
                    <img src="https://robomd.io/static/media/default_plus.466aee97.svg" style={{ width: 14, filter: "brightness(0)" }} alt="+" /> 새 콘텐츠 만들기
                  </Button>
                </div>
              </section>

              <section className="list-section-wrapper">
                <div className="filter-header">
                  <div className="filter-controls-row">
                    <div className="search-box-unified">
                      {/* <span className="search-icon">⌕</span> */}
                      <i className="search-icon fa fa-solid fa-magnifying-glass"></i>
                      <TextInput
                        type="text"
                        id="search_q"
                        placeholder="게시물 문구 검색..."
                        value={q}
                        onChange={(e, value) => {
                          this.setState({ q: value });
                        }}
                        width="100%"
                        height="38px"
                        onKeyDown={(e) => {
                          if (e.key === "Enter") {
                            this.setState({ page: 1 }, this.fetchPostsFromApi);
                          }
                        }}
                      />
                    </div>

                    <div className="filter-select-wrap">
                      <SelectBoxV2
                        id="statusSelect"
                        className="form-control"
                        pageWrapperName="common-page-wrapper"
                        width="100%"
                        height="40px"
                        padding="6px 30px 6px 10px"
                        list={STATUS_OPTIONS}
                        optionTexttName="text"
                        optionValuetName="value"
                        selectedValue={this.state.status}
                        placeHolder="전체 상태"
                        onClickOption={this.handleSelectBox("status")}
                        tabIndex={0}
                      />
                    </div>

                    <div className="filter-select-wrap">
                      <SelectBoxV2
                        id="typeSelect"
                        className="form-control"
                        pageWrapperName="common-page-wrapper"
                        width="100%"
                        height="40px"
                        padding="6px 30px 6px 10px"
                        list={TYPE_OPTIONS}
                        optionTexttName="text"
                        optionValuetName="value"
                        selectedValue={this.state.is_auto}
                        placeHolder="전체 유형"
                        onClickOption={this.handleSelectBox("is_auto")}
                        tabIndex={0}
                      />
                    </div>

                    <div className="date-range-group">
                      <div className="date-picker-wrapper">
                        <DatePicker
                          selected={startDate}
                          onChange={(date) => this.setState({ startDate: date, page: 1 })}
                          selectsStart
                          startDate={startDate}
                          endDate={endDate}
                          maxDate={endDate || undefined}
                          dateFormat="yyyy.MM.dd"
                          locale={ko}
                          isClearable
                          placeholderText="시작일"
                          customInput={<input className="date-input" />}
                        />
                      </div>
                      <span style={{ color: "var(--text-muted)" }}>~</span>
                      <div className="date-picker-wrapper">
                        <DatePicker
                          selected={endDate}
                          onChange={(date) => this.setState({ endDate: date, page: 1 })}
                          selectsEnd
                          startDate={startDate}
                          endDate={endDate}
                          minDate={startDate || undefined}
                          dateFormat="yyyy.MM.dd"
                          locale={ko}
                          isClearable
                          placeholderText="종료일"
                          customInput={<input className="date-input" />}
                        />
                      </div>
                    </div>

                    <button className="btn-apply" type="button" onClick={() => this.setState({ page: 1 }, this.fetchPostsFromApi)}>
                      필터 적용
                    </button>
                  </div>

                  <div className="filter-chips-row">
                    <div className="chip-group">
                      <button type="button" className={"chip-btn" + (!dateType || dateType === "all" ? " active" : "")} onClick={() => this.setQuickRange("all")}>전체</button>
                      <button type="button" className={"chip-btn" + (dateType === "today" ? " active" : "")} onClick={() => this.setQuickRange("today")}>오늘</button>
                      <button type="button" className={"chip-btn" + (dateType === "week" ? " active" : "")} onClick={() => this.setQuickRange("week")}>이번 주</button>
                      <button type="button" className={"chip-btn" + (dateType === "month" ? " active" : "")} onClick={() => this.setQuickRange("month")}>이번 달</button>
                    </div>
                    <div className="total-count">총 <span>{this.fmtNumber(total)}</span>개 게시물</div>
                  </div>
                </div>

                <div className="table-responsive">
                  <table className="robo-table">
                    <thead>
                      <tr>
                        <th style={{ width: "4%" }}>No.</th>
                        <th style={{ width: "6%" }}>이미지</th>
                        {this.renderSortHead("피드 문구 (캡션)", "caption", "left", "16%")}
                        <th style={{ width: "9%" }}>계정</th>
                        <th style={{ width: "6%" }}>유형</th>
                        <th style={{ width: "12%" }}>자동화 설정</th>
                        <th style={{ width: "8%" }}>상태</th>
                        {this.renderSortHead("생성 일시", "reg_date", "center", "9%")}
                        {this.renderSortHead("게시 일시", "published_time", "center", "12%")}
                        <th
                          style={{ width: "10%" }}
                          {...(this.state.tutorialListLoaded && rows.length === 0
                            ? { "data-instagram-tutorial": "post-engagement-empty" }
                            : {})}
                        >
                          참여
                        </th>
                        <th style={{ width: "7%", minWidth: "88px" }}>삭제</th>
                      </tr>
                    </thead>
                    <tbody>
                      {rows.length === 0 ? (
                        <tr>
                          <td colSpan={11} className="empty-row">
                            조건에 맞는 게시물이 없습니다.
                          </td>
                        </tr>
                      ) : (
                        rows.map((row, rowIndex) => {
                          const instagramEngagement = (row.like_cnt ?? 0) + (row.comment_cnt ?? 0) + (row.view_cnt ?? 0);
                          const threadsEngagement = (row.threads_like_cnt ?? 0) + (row.threads_reply_cnt ?? 0) + (row.threads_view_cnt ?? 0);
                          const showInstagramEngagement = row.instagramPublishYn !== "N";
                          const showThreadsEngagement = row.threadsPublishYn === "Y";
                          const showInstagramPublishDate = row.instagramPublishYn !== "N";
                          const showThreadsPublishDate = row.threadsPublishYn === "Y";
                          const isFutureScheduled = row.status === "예약됨" && row.publishedDate && row.publishedTime
                            ? new Date(`${row.publishedDate.replaceAll(".", "-")}T${row.publishedTime}:00`) > new Date()
                            : false;
                          const canEditPost = row.status === "임시저장" || isFutureScheduled;
                          const statusClass =
                            row.status === "게시됨" ? "badge-blue" :
                            row.status === "예약됨" ? "badge-gray" :
                            row.status === "임시저장" ? "badge-yellow" :
                            row.status === "실패" ? "badge-red" : "badge-gray";

                          return (
                            <tr
                              key={row.id}
                              onClick={() => {
                                if (canEditPost) {
                                  window.location.href = `/shop/instagram/InstagramCreatePost?media_id=${row.id}`;
                                }
                              }}
                              style={{ cursor: canEditPost ? "pointer" : "default" }}
                            >
                              <td data-label="No." className="list-no">{total - ((page - 1) * pageSize + rowIndex)}</td>
                              <td data-label="이미지">
                                <PreviewTrigger
                                  align="right"
                                  previewData={{
                                    slides: row.slides,
                                    caption: row.caption,
                                    hashtags: row.hashtags,
                                    publishedAt: row.publishedDate && row.publishedTime ? `${row.publishedDate} ${row.publishedTime}` : null,
                                    metrics: { likes: row.like_cnt, comments: row.comment_cnt, saves: row.view_cnt },
                                    instagramPublishYn: row.instagramPublishYn,
                                    threadsPublishYn: row.threadsPublishYn,
                                    threadsMetrics: {
                                      likes: row.threads_like_cnt,
                                      replies: row.threads_reply_cnt,
                                      views: row.threads_view_cnt,
                                    },
                                    image_ratio: row.image_ratio,
                                    reelsAudio: row.reelsAudio,
                                  }}
                                >
                                  {row.thumbnail && !this.looksLikeVideoUrl(row.thumbnail) ? (
                                    <div className="thumb-media">
                                      <img src={row.thumbnail} alt="thumbnail" />

                                      {row.isVideoPost && (
                                        <>
                                          <div className="thumb-video-dim"></div>
                                          <div className="thumb-play-icon">
                                            <span></span>
                                          </div>
                                        </>
                                      )}

                                      {row.carouselCount ? (
                                        <div className="thumb-count-badge">+{row.carouselCount}</div>
                                      ) : null}
                                    </div>
                                  ) : (
                                    <div className="thumb-media thumb-placeholder">
                                      {!row.isVideoPost && (
                                        <span>이미지<br />없음</span>
                                      )}
                                      {row.isVideoPost && (
                                        ((row.slides || []).find((s) => s && s.type === "video" && s.url) || row.thumbnail) ? (
                                          <>
                                            <video
                                              src={
                                                ((row.slides || []).find((s) => s && s.type === "video" && s.url) || {}).url
                                                || (this.looksLikeVideoUrl(row.thumbnail) ? row.thumbnail : "")
                                              }
                                              muted
                                              playsInline
                                              preload="metadata"
                                              style={{
                                                width: "100%",
                                                height: "100%",
                                                objectFit: "cover",
                                                display: "block",
                                                background: "#111827"
                                              }}
                                            />

                                            <div className="thumb-video-dim"></div>

                                            <div className="thumb-play-icon">
                                              <span></span>
                                            </div>
                                          </>
                                        ) : (
                                          <div className="thumb-play-icon">
                                            <span></span>
                                          </div>
                                        )
                                      )}
                                    </div>
                                  )}
                                </PreviewTrigger>
                              </td>
                              <td data-label="문구" className="text-left caption-text" title={row.caption || ""}>
                                <span className="caption-preview">{this.formatCaptionPreview(row.caption)}</span>
                              </td>
                              <td data-label="계정">
                                <div className="platform-account-list">

                                  {row.instagramPublishYn !== "N" && (
                                    <div className="platform-account-row">
                                      <span className="platform-account-label instagram">
                                        Instagram
                                      </span>
                                      <span className="platform-account-name">
                                        {row.username ? `@${row.username}` : "-"}
                                      </span>
                                    </div>
                                  )}

                                  {row.threadsPublishYn === "Y" && (
                                    <div className="platform-account-row">
                                      <span className="platform-account-label threads">
                                        Threads
                                      </span>
                                      <span className="platform-account-name">
                                        {row.threadsUsername ? `@${row.threadsUsername}` : "-"}
                                      </span>
                                    </div>
                                  )}

                                </div>
                              </td>
                              <td data-label="유형">
                                <span className={"badge " + (row.isAuto === "Y" ? "badge-mint" : "badge-gray")}>{row.isAutoText || "-"}</span>
                              </td>
                              <td data-label="자동화 설정">
                                {row.instagramAiImageAutoSettingSeq ? (
                                  <a
                                    className="cell-link"
                                    href={`/shop/instagram/InstagramCreateAiImageAutomation?instagram_ai_image_auto_setting_seq=${encodeURIComponent(row.instagramAiImageAutoSettingSeq)}`}
                                    title={row.autoSettingName || ""}
                                    onClick={(e) => e.stopPropagation()}
                                  >
                                    {row.autoSettingName || "-"}
                                  </a>
                                ) : row.instagramProductAutoSettingSeq ? (
                                  <a
                                    className="cell-link"
                                    href={`/shop/instagram/InstagramCreateProductAutomation?instagram_product_auto_setting_seq=${encodeURIComponent(row.instagramProductAutoSettingSeq)}`}
                                    title={row.autoSettingName || ""}
                                    onClick={(e) => e.stopPropagation()}
                                  >
                                    {row.autoSettingName || "-"}
                                  </a>
                                ) : (
                                  <span className="cell-link" title={row.autoSettingName || ""}>
                                    {row.autoSettingName || "-"}
                                  </span>
                                )}
                              </td>
                              <td data-label="상태">
                                <span className={"badge " + statusClass}>
                                  {
                                    row.status === "게시됨" || row.status === "실패"
                                    ? <i className={"f-s-12 f-w-900"+(row.status === "게시됨" ? " fa fa-solid fa-circle-check" : row.status === "실패" ? " fa fa-solid fa-circle-exclamation" : "")}></i>
                                    : ""
                                  }
                                  {row.status || "-"}
                                </span>
                              </td>
                              <td data-label="생성 일시" className="cell-date">
                                {row.createdDate || "-"}<br />
                                <span>{row.createdTime || ""}</span>
                              </td>
                              <td data-label="게시 일시" className="cell-date">
                                <div className="platform-date-list">
                                  {showInstagramPublishDate && (
                                    <div className="platform-date-row">
                                      <span className="platform-engagement-label instagram">Instagram</span>
                                      <div className="platform-date-value">
                                        {row.instagramPublishedDate || "-"}
                                        <span>{row.instagramPublishedTime || ""}</span>
                                      </div>
                                    </div>
                                  )}

                                  {showThreadsPublishDate && (
                                    <div className="platform-date-row">
                                      <span className="platform-engagement-label threads">Threads</span>
                                      <div className="platform-date-value">
                                        {row.threadsPublishedDate || "-"}
                                        <span>{row.threadsPublishedTime || ""}</span>
                                      </div>
                                    </div>
                                  )}

                                  {!showInstagramPublishDate && !showThreadsPublishDate ? <span>-</span> : null}
                                </div>
                              </td>
                              <td
                                data-label="참여"
                                data-instagram-tutorial={
                                  this.state.tutorialListLoaded && rowIndex === 0
                                    ? "post-engagement-row"
                                    : undefined
                                }
                              >
                                <div className="platform-engagement-list">
                                  {showInstagramEngagement && (
                                    <div className="platform-engagement-row">
                                      <span className="platform-engagement-label instagram">Instagram</span>
                                      <div className={"engagement-box" + (instagramEngagement > 0 ? " active" : "")}>
                                        <div className="engagement-item"><span className="engagement-heart fa fa-heart"></span> {this.fmtNumber(row.like_cnt)}</div>
                                        <div className="engagement-item"><span className="engagement-comment fa fa-comment"></span> {this.fmtNumber(row.comment_cnt)}</div>
                                        <div className="engagement-item"><span className="engagement-view fa fa-eye"></span> {this.fmtNumber(row.view_cnt)}</div>
                                      </div>
                                    </div>
                                  )}

                                  {showThreadsEngagement && (
                                    <div className="platform-engagement-row">
                                      <span className="platform-engagement-label threads">Threads</span>
                                      <div className={"engagement-box" + (threadsEngagement > 0 ? " active" : "")}>
                                        <div className="engagement-item"><span className="engagement-heart fa fa-heart"></span> {this.fmtNumber(row.threads_like_cnt)}</div>
                                        <div className="engagement-item"><span className="engagement-comment fa fa-comment"></span> {this.fmtNumber(row.threads_reply_cnt)}</div>
                                        <div className="engagement-item"><span className="engagement-view fa fa-eye"></span> {this.fmtNumber(row.threads_view_cnt)}</div>
                                      </div>
                                    </div>
                                  )}

                                  {!showInstagramEngagement && !showThreadsEngagement && (
                                    <div className="engagement-empty">-</div>
                                  )}
                                </div>
                              </td>
                              <td data-label="관리">
                                <div className="post-action-wrap">
                                  <button
                                    type="button"
                                    className="post-delete-btn"
                                    onClick={(e) => this.onDelete(row, e)}
                                  >
                                    <i className="fa fa-solid fa-trash"></i>
                                    삭제
                                  </button>
                                </div>
                              </td>
                            </tr>
                          );
                        })
                      )}
                    </tbody>
                  </table>
                </div>

                <div className="pagination-container">
                  <div className="mobile-display-none"></div>
                  <div className="page-numbers">
                    <button type="button" disabled={page <= 1} onClick={() => this.goPage(page - 1)}><i className="fa fa-solid fa-caret-left f-s-13"></i></button>
                    {Array.from({ length: Math.min(5, totalPages) }).map((_, i) => {
                      const half = Math.floor(5 / 2);
                      let start = Math.max(1, page - half);
                      let end = Math.min(totalPages, start + 4);
                      if (end - start < 4) start = Math.max(1, end - 4);
                      const p = start + i;
                      if (p > totalPages) return null;
                      return (
                        <button key={p} type="button" className={p === page ? "active" : ""} onClick={() => this.goPage(p)}>
                          {p}
                        </button>
                      );
                    })}
                    <button type="button" disabled={page >= totalPages} onClick={() => this.goPage(page + 1)}><i className="fa fa-solid fa-caret-right f-s-13"></i></button>
                  </div>

                  <div className="page-size-selector">
                    <span>페이지당</span>
                    <SelectBoxV2
                      id="pageSizeSelect"
                      className="form-control"
                      pageWrapperName="common-page-wrapper"
                      width="120px"
                      height="32px"
                      padding="6px 30px 6px 10px"
                      list={pageSizes}
                      optionTexttName="text"
                      optionValuetName="value"
                      selectedValue={this.state.pageSize}
                      placeHolder="페이지 크기"
                      onClickOption={(text, value) => this.changePageSize({ target: { value } })}
                      tabIndex={0}
                    />
                  </div>
                </div>
              </section>
            </div>
          </main>

          {this.state.deleteDialogOpen && this.state.deleteTarget && (
            <TitleContentDialogV2
              title={
                this.state.deleteTarget.status === "게시됨"
                  ? "게시물을 삭제하시겠습니까?"
                  : `${this.state.deleteTarget.status || ""} 게시물을 삭제하시겠습니까?`
              }
              content={this.getDeleteDialogContent()}
              check_box_list={this.getDeleteDialogCheckBoxList()}
              popup_close={this.closeDeleteDialog}
              button_list={[
                {
                  title: this.state.deleteProcessing ? "삭제 중..." : "삭제",
                  event_method: this.deletePost,
                },
                {
                  title: "취소",
                  event_method: this.closeDeleteDialog,
                },
              ]}
            />
          )}
          {this.state.save_dialog_show_state && (
            <SaveDialogV2
              content={this.state.save_dialog_content}
              button_list={this.state.save_dialog_button_list}
            />
          )}
        </div>
      </PreviewRoot>
    );
  }
}